import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Card, CardBody, Col, Container, Row } from 'reactstrap';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { connect, useSelector } from 'react-redux';
import OrderItemAddorUpdate from './OrderItemAddorUpdate';
import OrderBillingAddorUpdate from './OrderBillingAddorUpdate';
import { ERROR_MESSAGES, ORDER_TYPE_PICK_N_DROP, ORDER_TYPE_PICK_UP } from 'src/utils/pnd/PndConstants';
import MerchantPickAndDrop from './MerchantPickAndDrop';
import MerchantPickUp from './MerchantPickUp';
import renderSelectField from 'src/shared/components/form/Select';
import renderDateTimePickerField from 'src/shared/components/form/DateTimePicker';
import AssignmentIcon from '@mui/icons-material/Assignment';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// import HubIcon from '@mui/icons-material/Hub';
// import TimerIcon from '@mui/icons-material/Timer';

const required = value => value ? undefined : 'Required'

const MerchantOrderProcessingMain = ({ dispatch, itemDetails, setItemDetails, handleSubmit, isInfo, isMerchantPickUpPoint, isMerchantAssignedHub, isOrderItemDetails, isId, setOrderItemDetails }) => {
   const orderPreferences = useSelector(state => state.orderPreferences);

   useEffect(() => {
        getAllMerchantCustomerDetails();
        if (isInfo?.orderType) {
            setSelectedOrderType(Number(isInfo?.orderType));
        }
        if (!isInfo) {
            const fields = [
                'orderNo', 'orderPriorityInfo', 'requestedDateTimeSlot', 'orderType', 'orderFromAddressTypeInfo',
                'merchantInfo', 'collectionPointId', 'hubInfo', 'orderToAddressTypeInfo', 'shortCode', 'address',
                'buildingName', 'contactNo', 'postalCode', 'doorNo', 'toFloorNo', 'emiratesName', 'contactPersonName',
                'areaName', 'grlCode', 'name', 'toAddress', 'toAddressName', 'toAddressShortCode', 'toAddressBuildingName',
                'toAddressContactNumber', 'toAddressPostalCode', 'toAddressDoorNo', 'toAddressFloorNo',
                'toAddressContactPersonName', 'toAddressAreaName', 'toAddressGrlCode', 'invoiceNo', 'salesOrderNo',
                'toUniqueId', 'orderZoneId', 'orderProcessingAreaRate', 'paymentMethodInfo', 'deliveryChargeBearerInfo',
                'orderSalesAmount', 'orderAmount', 'orderTotalAmount', 'orderInstruction', 'numberOfBox_1',
                'weightKg_1', 'length_1', 'width_1', 'height_1', 'boxDescription_1'
            ];
            fields.forEach(field => dispatch(change('orderForm', field, "")));
        }
    }, [dispatch, isInfo]);

    const [loading, setLoading] = useState(false);
    const [isCustomersId, setCustomersId] = useState([]);
    const [isSelectedOrderType, setSelectedOrderType] = useState(null);

    const getAllMerchantCustomerDetails = async () => {
        try {
            setLoading(true);
            const response = await PndRestApi.GetAllMerchantCustomers(localStorage.getItem('mi'));
            if (response.status === 200 && response.data.status === 200) {
                const customersId = response.data.data
                    .filter(item => item.status === 1)
                    .map(item => ({ label: item.customerName, value: item.merchantCustomerId }));
                setCustomersId(customersId);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data.message}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", `SuccessCode: 500`, ERROR_MESSAGES.tryCatchError);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="p-0">
            <form className="form" onSubmit={handleSubmit}>
                <Card className="border-0 shadow-sm mb-3">
                    <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-4 text-primary border-bottom pb-2">
                            <AssignmentIcon style={{ fontSize: '1.5rem' }} className="me-2" />
                            <h5 className="m-0 fw-bold">Order Creation & Processing</h5>
                        </div>

                        <Row className="g-3 mb-4">
                            {isInfo?.orderNo && (
                                <Col lg={2} md={6}>
                                    <div className="mb-2">
                                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Order / Tracking No.</label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light border-end-0"><AssignmentIcon style={{ fontSize: '1rem' }} /></span>
                                            <input className="form-control form-control-sm border-start-0" value={isInfo?.orderNo} disabled={true} style={{ fontSize: '0.85rem' }} />
                                        </div>
                                    </div>
                                </Col>
                            )}
                            <Col lg={2} md={6}>
                                <div className="mb-2">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Order Type <span className='text-danger'>*</span></label>
                                    <Field
                                        validate={[required]}
                                        name="orderType"
                                        component={renderSelectField}
                                        options={[
                                            orderPreferences?.data?.pickupEnabled && { value: 2, label: "Pick Up" },
                                            orderPreferences?.data?.pickAndDropEnabled && { value: 3, label: "Pick & Drop" },
                                        ].filter(Boolean)}
                                        placeholder="Select Type"
                                        onChange={events => setSelectedOrderType(events?.value)}
                                        isDisabled={!!isInfo?.orderNo}
                                    />
                                </div>
                            </Col>
                            <Col lg={3} md={6}>
                                <div className="mb-2">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Order Priority <span className='text-danger'>*</span></label>
                                    <Field validate={[required]} name="orderPriorityInfo" component={renderSelectField} options={[
                                        { value: 1, label: "Express Delivery" },
                                        { value: 2, label: "Same Day Delivery" },
                                        { value: 3, label: "Scheduled Delivery" },
                                    ]} placeholder="Select Priority" />
                                </div>
                            </Col>
                            <Col lg={3} md={6}>
                                <div className="mb-2">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Order Posting To <span className='text-danger'>*</span></label>
                                    <Field validate={[required]} name="toUniqueId" component={renderSelectField} options={isMerchantAssignedHub} placeholder="Select Hub" />
                                </div>
                            </Col>
                            <Col lg={2} md={6}>
                                <div className="mb-2">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Requested Time <span className='text-danger'>*</span></label>
                                    <Field name="requestedDateTimeSlot" component={renderDateTimePickerField} />
                                </div>
                            </Col>
                        </Row>

                        {(Number(isSelectedOrderType) === ORDER_TYPE_PICK_UP || Number(isInfo?.orderType) === ORDER_TYPE_PICK_UP) && (
                            <MerchantPickUp isMerchantPickUpPoint={isMerchantPickUpPoint} isCustomersId={isCustomersId} isInfo={isInfo} dropOffRequiredLaterValue={isInfo?.dropOffRequiredLater} />
                        )}

                        {(Number(isSelectedOrderType) === ORDER_TYPE_PICK_N_DROP || Number(isInfo?.orderType) === ORDER_TYPE_PICK_N_DROP) && (
                            <MerchantPickAndDrop isMerchantPickUpPoint={isMerchantPickUpPoint} isCustomersId={isCustomersId} isInfo={isInfo} />
                        )}

                        <OrderBillingAddorUpdate isInfo={isInfo} />

                        <OrderItemAddorUpdate setItemDetails={setItemDetails} itemDetails={itemDetails} isOrderItemDetails={isOrderItemDetails} isId={isId} setOrderItemDetails={setOrderItemDetails} isInfo={isInfo} />

                        {orderPreferences?.data?.orderEditableEnabled && (
                            <div className="d-flex justify-content-center mt-4">
                                <ButtonToolbar>
                                    <Button color="success" type="submit" className="px-4 py-2 rounded-pill shadow-sm" style={{ fontWeight: 600 }}>
                                        {isId ? "Update Order" : "Submit Order"}
                                    </Button>
                                </ButtonToolbar>
                            </div>
                        )}
                    </CardBody>
                </Card>
            </form>
        </Container>
    );
};

MerchantOrderProcessingMain.propTypes = {
    dispatch: PropTypes.func.isRequired,
    itemDetails: PropTypes.array,
    setItemDetails: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    isInfo: PropTypes.object,
    isMerchantPickUpPoint: PropTypes.array,
    isMerchantAssignedHub: PropTypes.array,
    isOrderItemDetails: PropTypes.array,
    isId: PropTypes.string,
    setOrderItemDetails: PropTypes.func,
};

const mapStateToProps = (state, data) => {
    const prefs = state.orderPreferences?.data || {};
    const enabledTypes = [
        prefs.pickupEnabled && { value: 2, label: "Pick Up" },
        prefs.pickAndDropEnabled && { value: 3, label: "Pick & Drop" },
    ].filter(Boolean);

    let toMerchantLabel;
    let toHubLabel;
    let FromMerchantLabel;
    let FromHubLabel;
    let collectionPointLabel = null;
    if (data && data?.isInfo) {
        if (data?.isMerchant?.length > 0 && data?.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId === 3 && data?.isInfo?.toUniqueId) {
            const merchant = data?.isMerchant.find(merchant => merchant.value === data?.isInfo?.toUniqueId);
            if (merchant) toMerchantLabel = merchant?.label;
        }
        if (data?.isMerchantAssignedHub?.length > 0 && data?.isInfo?.toUniqueId) {
            const hub = data?.isMerchantAssignedHub.find(hub => hub.value === data?.isInfo?.toUniqueId);
            if (hub) toHubLabel = hub?.label;
        }
        if (data?.isMerchant?.length > 0 && data?.isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId === 3 && data?.isInfo?.fromUniqueId) {
            const merchant = data?.isMerchant.find(merchant => merchant?.value === data?.isInfo?.fromUniqueId);
            if (merchant) FromMerchantLabel = merchant?.label;
        }
        if (data?.isHub?.length > 0 && data?.isInfo?.toUniqueId) {
            const hub = data?.isHub.find(hub => hub.value === data?.isInfo?.toUniqueId);
            if (hub) FromHubLabel = hub?.label;
        }
        if (data?.isMerchantPickUpPoint?.length > 0 && data?.isInfo?.collectionPointId) {
            const collectionPointLabelFinder = data?.isMerchantPickUpPoint.find(picPoint => picPoint.value === data?.isInfo?.collectionPointId);
            if (collectionPointLabelFinder) collectionPointLabel = collectionPointLabelFinder?.label;
        }

        const fromAddressTypeId = Number(
            data.isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId ??
            data.isInfo?.orderFromAddressTypeId ??
            data.isInfo?.fromAddressTypeId
        );

        const isOrderFromMerchantCustomer =
            fromAddressTypeId === 5 ||
            data.isInfo?.orderFromAddressTypeInfo?.label === "Merchant Customer" ||
            data.isInfo?.fromUniqueId === 5 ||
            (!data.isInfo?.collectionPointId && (data.isInfo?.name || data.isInfo?.shortCode || data.isInfo?.address || data.isInfo?.contactNo));

        const custId = data.isInfo?.fromUniqueId ?? data.isInfo?.toUniqueId;
        const custName = data.isInfo?.name || data.isInfo?.customerName || data.isInfo?.fromName || '';
        const custSelectVal = (custId || custName) ? { value: custId, label: custName } : null;

        return {
            initialValues: {
                orderId: data.isInfo?.orderId,
                name: custSelectVal,
                orderType: data?.isInfo?.orderType ? {
                    value: Number(data.isInfo.orderType),
                    label: Number(data.isInfo.orderType) === 1 ? "Drop Off" : Number(data.isInfo.orderType) === 2 ? "Pick Up" : Number(data.isInfo.orderType) === 3 ? "Pick & Drop" : "Pick Up"
                } : null,
                orderFromAddressTypeInfo: isOrderFromMerchantCustomer
                    ? { value: 0, label: "Merchant Customer" }
                    : {
                        value: data.isInfo?.collectionPointId || data.isInfo?.fromUniqueId,
                        label: collectionPointLabel || data.isInfo?.collectionPointName || (data.isInfo?.collectionPointId ? `Pick Up Point ${data.isInfo.collectionPointId}` : null)
                    },
                orderToAddressTypeInfo: {
                    value: Number(data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId),
                    label: Number(data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) === 1 ? "Own Hub" : Number(data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) === 2 ? "Hub Customer" : Number(data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) === 3 ? "Merchant" : Number(data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) === 4 ? "Another Hub" : Number(data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) === 5 ? "Merchant Customer" : null
                },
                contactNo: data.isInfo?.contactNo,
                doorNo: data.isInfo?.doorNo,
                postalCode: data.isInfo?.postalCode,
                contactPersonName: data.isInfo?.contactPersonName,
                address: data.isInfo?.address,
                emiratesName: data.isInfo?.emiratesName,
                areaName: data.isInfo?.areaName,
                buildingName: data.isInfo?.buildingName,
                floorNo: data.isInfo?.floorNo,
                toFloorNo: data.isInfo?.toFloorNo,
                shortCode: data.isInfo?.shortCode,
                grlCode: data.isInfo?.grlCode,
                orderPriorityInfo: (() => {
                    const pId = data?.isInfo?.orderPriorityInfo?.orderPriorityId ?? data?.isInfo?.orderPriorityId;
                    if (!pId) return null;
                    const numPId = Number(pId);
                    const pLabel = numPId === 1 ? "Express Delivery" : numPId === 2 ? "Same Day Delivery" : numPId === 3 ? "Scheduled Delivery" : (data?.isInfo?.orderPriorityInfo?.orderPriorityName || data?.isInfo?.orderPriorityName || "");
                    return { value: numPId, label: pLabel };
                })(),
                requestedDateTimeSlot: data?.isInfo?.requestedDateTimeSlot ? new Date(data?.isInfo?.requestedDateTimeSlot) : null,
                scheduledDateTimeSlot: data?.isInfo?.scheduledDateTimeSlot ? new Date(data?.isInfo?.scheduledDateTimeSlot) : null,
                merchantInfo: data.isInfo?.merchantInfo ? {
                    value: data.isInfo.merchantInfo.merchantId,
                    label: data.isInfo.merchantInfo.merchantName
                } : (data.isInfo?.orderToAddressTypeInfo?.orderAddressTypeId === 3 ? { value: data?.isInfo?.toUniqueId, label: `${toMerchantLabel || data.isInfo?.merchantName || ''}` } : data.isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId === 3 ? { value: data?.isInfo?.fromUniqueId, label: `${FromMerchantLabel || data.isInfo?.merchantName || ''}` } : null),
                toUniqueId: data?.isInfo?.toUniqueId ? { value: data?.isInfo?.toUniqueId, label: toHubLabel || data?.isInfo?.toHubName || data?.isInfo?.hubName || 'Hub' } : null,
                invoiceNo: data.isInfo?.invoiceNo,
                orderInstruction: data.isInfo?.orderInstruction,
                orderNo: data.isInfo?.orderNo,
                orderProcessingAreaRate: data.isInfo?.orderProcessingAreaRate,
                orderSalesAmount: data.isInfo?.orderSalesAmount,
                orderTotalAmount: data.isInfo?.orderTotalAmount,
                paymentMethodInfo: { value: data?.isInfo?.paymentMethodInfo?.paymentMethodId, label: data?.isInfo?.paymentMethodInfo?.description },
                deliveryChargeBearerInfo: { value: data?.isInfo?.deliveryChargeBearerInfo?.deliveryChargeId, label: data?.isInfo?.deliveryChargeBearerInfo?.deliveryChargeBearerName },
                orderAmount: data.isInfo?.orderAmount,
                salesOrderNo: data?.isInfo?.salesOrderNo,
                remarks: data?.isInfo?.remarks,
                orderZoneId: { value: data?.isInfo?.orderZoneId, label: data?.isInfo?.orderZoneName },
                collectionPointId: isOrderFromMerchantCustomer ? null : (data.isInfo?.collectionPointId ? { value: data?.isInfo?.collectionPointId, label: collectionPointLabel || data.isInfo?.collectionPointName } : null),
                dropOffRequiredLater: data?.isInfo?.dropOffRequiredLater,
                toAddressShortCode: data?.isInfo?.toAddressShortCode,
                toAddressBuildingName: data?.isInfo?.toAddressBuildingName,
                toAddressName: data?.isInfo?.toAddressName ? { value: data?.isInfo?.toUniqueId || data?.isInfo?.fromUniqueId, label: data?.isInfo?.toAddressName } : null,
                toAddressContactNumber: data?.isInfo?.toAddressContactNumber,
                toAddressPostalCode: data?.isInfo?.toAddressPostalCode,
                toAddressDoorNo: data?.isInfo?.toAddressDoorNo,
                toAddressFloorNo: data?.isInfo?.toAddressFloorNo,
                toAddressContactPersonName: data?.isInfo?.toAddressContactPersonName,
                toAddressAreaName: data?.isInfo?.toAddressAreaName,
                toAddress: data?.isInfo?.toAddress,
                longitude: data.isInfo?.longitude,
                latitude: data.isInfo?.latitude
            }
        };
    }
    return {
        initialValues: enabledTypes.length === 1 ? { orderType: enabledTypes[0] } : {}
    };
};

export default connect(mapStateToProps)(
    reduxForm({
        form: "orderForm",
        enableReinitialize: true,
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    })(MerchantOrderProcessingMain)
);
